module.exports = __webpack_public_path__ + "img/title-id.baaf5216.png";